// Shared framer-motion variants for the Halo viewer. Centralized so motion stays
// consistent across pages. All transitions are short and spring-free by default;
// prefers-reduced-motion is additionally enforced globally in index.css.
import type { Variants } from "framer-motion";

export const easeOut: [number, number, number, number] = [0.16, 1, 0.3, 1];

/** Page-level enter/exit (route transitions). */
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 8 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.3, ease: easeOut } },
  exit: { opacity: 0, y: -6, transition: { duration: 0.18, ease: "easeIn" } },
};

/** Container that staggers its children in (grids, lists). */
export const staggerContainer: Variants = {
  initial: {},
  enter: { transition: { staggerChildren: 0.045, delayChildren: 0.02 } },
};

/** Individual item rising into place (cards, rows). */
export const riseItem: Variants = {
  initial: { opacity: 0, y: 12 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.34, ease: easeOut } },
};

/** Subtle hover lift for interactive cards. */
export const hoverLift = {
  rest: { y: 0 },
  hover: { y: -4, transition: { duration: 0.2, ease: easeOut } },
};
